import { $api } from "../AxiosInstance";

export class PageService {
  /**
   * Get all pages
   */
  static async pageGetAll() {
    return await $api.get("/api/page/all");
  }

  /**
   * Get page by ID
   * @param {Number} id
   */
  static async pageGet(id) {
    return await $api.get("/api/page", { params: { id } });
  }

  /**
   * Create page
   * @param {String} name
   * @param {String} tag
   * @param {String} pathname
   */
  static async pageCreate(name, tag, pathname) {
    return await $api.put("/api/page", { name, tag, pathname });
  }

  /**
   * Save page
   * @param {Number} id
   * @param {String} name
   * @param {String} tag
   * @param {String} pathname
   */
  static async pageSave(id, name, tag, pathname) {
    return await $api.post("/api/page", { id, name, tag, pathname });
  }

  /**
   * Get page content
   * @param {Number} pageId
   * @param {Number} translationId
   */
  static async pageContentGet(pageId, translationId) {
    return await $api.get("/api/page/content", {
      params: { pageId, translationId },
    });
  }

  /**
   * Get front page content
   * @param {String} tag
   * @param {String} languageCode
   */
  static async pageFrontContentGet(tag, languageCode) {
    return await $api.get("/api/page/front/content", {
      params: { tag, languageCode },
    });
  }

  /**
   * Save page content
   * @param {Number} pageId
   * @param {Number} translationId
   * @param {String} title
   * @param {String} description
   * @param {String} hContent
   * @param {String} h1
   * @param {String} h1Text
   * @param {String} h2
   * @param {String} h2Text
   */
  static async pageContentSave(
    pageId,
    translationId,
    title,
    description,
    hContent,
    h1,
    h1Text,
    h2,
    h2Text
  ) {
    return await $api.post("/api/page/content", {
      pageId,
      translationId,
      title,
      description,
      hContent,
      h1,
      h1Text,
      h2,
      h2Text,
    });
  }
}
